import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ArtfulCheckbox from '~/Components/Global/Form/ArtfulCheckbox';
import { updateUserOptions } from '~/Redux/Modules/UserOptions';

import './ToggleIntlTime.scss';

const ToggleIntlTime = () => {
  const userOptions = useSelector(({ UserOptions }) => UserOptions.data);
  const use_intl_time = userOptions?.use_intl_time;
  const dispatch = useDispatch();

  const setAutoRollover = use_intl_time => {
    dispatch(updateUserOptions(userOptions.id, { ...userOptions, use_intl_time }));
  };

  const handleClick = e => {
    e.stopPropagation();
  };

  return (
    <li className="toggle-intl-time" onClick={handleClick}>
      <span>
        <ArtfulCheckbox
          label="Use International Time"
          value={use_intl_time}
          onChange={() => setAutoRollover(!use_intl_time)}
          name="intlTime"
        />
      </span>
    </li>
  );
};

export default ToggleIntlTime;
